import * as React from 'react';
import { Button } from 'reactstrap';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import { ComboBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import i18n from 'i18next';

import AddIcon from '../../../../assets/icons/add-circle.svg?react';
import DeleteIcon from '../../../../assets/icons/delete.svg?react';
import { shareCalendar } from '../../../api/calendar-api';
import { validateEmail } from '../../../../services/validation';
import Spinner from '../../../../components/spinner/spinner';
import '../../../../app.scss';

// Access Control List
export class Acl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarid: this.props.calendarId,
      contacts: null,
      emailValue: '',
      emailError: '',
      permissionValue: '',
      loading: false
    };

    this.position = { X: 'Right', Y: 'Top' };
    this.temp = 'roleData';
    this.fields = { text: 'Role', value: 'Id' };
    this.value = '';
    this.listviewInstance = null;
    this.listviewContactsInstance = null;
    this.dataACLSource = this.props.aclData;
    this.fieldsList = { text: 'text', iconCss: 'icon' };
    this.contactFieldList = { text: 'text' };
    this.dataContactsSource = [];
    this.onAddPermission = this.onAddPermission.bind(this);

    this.toasts = [
      {
        content: i18n.t('schedule.toast-processing'),
        cssClass: 'e-toast-black',
        icon: ''
      },
      {
        content: i18n.t('schedule.toast-process-complete'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      },
      {
        content: i18n.t('schedule.toast-process-error'),
        cssClass: 'e-toast-danger',
        icon: 'lf-icon lf-icon-close-round'
      }
    ];

    this.roleData = [
      { Id: 'read', Role: 'lectura' },
      { Id: 'read-write', Role: 'lectura y escritura' }
    ];
  }

  toastCusAnimation = {
    hide: { duration: '1' },
    show: { duration: '200' }
  };

  getInvalidEmailMessage(email) {
    return validateEmail(email) ? i18n.t('acl.invalid_email') : '';
  }

  onAddPermission() {
    const email = (this.listviewContactsInstance?.value || '').trim();
    const emailError = this.getInvalidEmailMessage(email);

    if (emailError) {
      this.setState({ emailError });
      return;
    }

    if (
      this.permissionObj.value !== '' &&
      email !== '' &&
      !this.listviewInstance.dataSource.find(
        x => x.text === email
      )
    ) {
      const id = `user:${email}`;
      const aclData = {
        role: this.permissionObj.value,
        scope: {
          type: 'user',
          value: email
        },
        kind: 'calendar#aclRule',
        id: id
      };

      this.setState({ loading: true, emailError: '' });
      shareCalendar(
        this.state.calendarid,
        aclData,
        this.props.userId,
        this.props.userAccount,
        this.props.lexonToken
      )
        .then(() => {
          this.toastObj.hide('All');
          this.setState({ loading: false });
          const dataPermission = {
            text: email,
            role: i18n.t(`${this.permissionObj.value}`),
            id: id,
            icon: 'delete-icon'
          };
          this.listviewInstance.addItem([dataPermission]);
        })
        .catch(() => {
          if (this.toastObj != undefined) {
            this.setState({ loading: false });
            this.toastObj.hide('All');
            this.toastObj.show(this.toasts[2]);
          }
        });
    }
  }

  deleteItem(args) {
    args.stopPropagation();
    const liItem = args.target.closest('[data-uid]');

    if (!liItem || !liItem.dataset.uid) {
      console.error('No se encontró el elemento con data-uid');
      return;
    }

    const aclData = {
      role: 'delete',
      scope: {
        type: 'user',
        value: liItem.dataset.uid.replace('user:', '')
      },
      kind: 'calendar#aclRule',
      id: liItem.dataset.uid
    };

    this.setState({ loading: true });
    shareCalendar(
      this.state.calendarid,
      aclData,
      this.props.userId,
      this.props.userAccount,
      this.props.lexonToken
    )
      .then(() => {
        this.toastObj.hide('All');
        this.setState({ loading: false });
        this.listviewInstance.removeItem(liItem);
        this.listviewInstance.refresh();
      })
      .catch(() => {
        if (this.toastObj != undefined) {
          this.setState({ loading: false });
          this.toastObj.hide('All');
          this.toastObj.show(this.toasts[2]);
        }
      });
  }

  onContactsDataBinding(items) {
    if (items && items.data && items.data.length > 0) {
      items.data.forEach(user => {
        this.dataContactsSource.push({
          text: user.id
        });
      });
    }
    this.listviewContactsInstance.refresh();
  }

  listTemplate(data) {
    let owner = false;
    if (data.role == 'owner') {
      owner = true;
    }

    return (
      <div className="text-content">
        <span>{data.text} ({i18n.t(`acl.${data.role}`)})</span>
        {!owner ? (
          <DeleteIcon className="acl-delete-icon" onClick={this.deleteItem.bind(this)} />
        ) : (
          ''
        )}
      </div>
    );
  }

  contactListTemplate(data) {
    return <div className="text-content">{data.text}</div>;
  }

  render() {
    const { emailValue, emailError, permissionValue } = this.state;
    return (
      <React.Fragment>
        <Spinner
          visible={this.state.loading}
          className="spinner-calendar"
          pathClassName={`spinnerPath`}
        />
        <div className="calendar-permission-container mb-4">
          <label
            id="label_name"
            htmlFor="name"
            className="inter-medium-14 text-color-blue-lefebvre"
          >
            {i18n.t('calendar-sidebar.permission')}
          </label>
          <div className="calendar-permission-divider mb-3"/>
          <ListViewComponent
            id="permission-list"
            dataSource={this.props.aclData.filter(
              x => x.text !== this.props.userAccount
            )}
            fields={this.fieldsList}
            template={this.listTemplate.bind(this)}
            ref={listview => {
              this.listviewInstance = listview;
            }}
          />
          {emailError ? <div className="text-danger mt-2">{emailError}</div> : null}

          <div className="d-flex align-items-center">
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
              <div className="form-group">
                <div className="e-float-input">
                  <label className="inter-regular-14 text-color-grey-800">
                    {i18n.t('acl.emailaddresses')}
                  </label>
                  <ComboBoxComponent
                    id="contact-list"
                    className="field-input"
                    dataSource={this.props.contacts}
                    fields={this.contactFieldList}
                    placeholder={i18n.t('calendar.email_example')}
                    popupHeight="220px"
                    change={e => {
                      const nextEmailValue = e.value || '';
                      this.setState({
                        emailValue: nextEmailValue,
                        emailError: nextEmailValue === ''
                          ? ''
                          : this.getInvalidEmailMessage(nextEmailValue)
                      });
                    }}
                    template={this.contactListTemplate.bind(this)}
                    ref={contactslistview => {
                      this.listviewContactsInstance = contactslistview;
                    }}
                    showClearButton={false}
                  />
                  <span className="input-divider" />
                </div>
                <div id="noError" />
              </div>
            </div>
            <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
              <div className="form-group">
                <div className="e-float-input">
                  <label className="inter-regular-14 text-color-grey-800">
                    {i18n.t('acl.permissions')}
                  </label>
                  <ComboBoxComponent
                    id="roles"
                    dataSource={this.roleData}
                    className="field-input"
                    ref={combobox => {
                      this.permissionObj = combobox;
                    }}
                    fields={this.fields}
                    change={e => {
                      this.setState({ permissionValue: e.value });
                    }}
                    placeholder={i18n.t('general.select_option')}
                    value={this.value}
                    popupHeight="220px"
                    showClearButton={false}
                  />
                  <span className="input-divider" />
                </div>
                <div id="noError" />
              </div>
            </div>
            <div className="btn-sharing-container">
              <Button
                disabled={emailValue === '' || permissionValue === ''}
                id="modify"
                color="primary"
                title={i18n.t('acl.add')}
                onClick={this.onAddPermission}
                className="btn-add-sharing inter-semibold-14"
              >
                <AddIcon className="lf-icon-add-round" />
                {i18n.t('acl.add')}
              </Button>
            </div>
          </div>
          <div className="calendar-permission-divider"/>
          <ToastComponent
            ref={toast => {
              this.toastObj = toast;
            }}
            id="toast_pos"
            position={this.position}
            target={this.target}
            animation={this.toastCusAnimation}
            timeOut={7000}
            showCloseButton
            open={true}
          ></ToastComponent>
        </div>
      </React.Fragment>
    );
  }
}

export default Acl;
